import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as history from "app/main/history";
import { observeResource } from "kea-resource";
import { resources, selectores } from "app/main/std";
import { createSelector } from "reselect";
import { ServiciosAdicionales } from "./../../../../catalogos/items/tarifaPP/edit/servadic";

type Entity = models.DatosPaquetePPModel

interface Props {
    value: Entity;
    onChange: (x: Entity) => void;
}

export function validar(x: Entity): kea.validation.Result<Entity> {
    const rules: kea.validation.Rules<Entity> = {
        IdCliente: kea.validation.required,
        IdTarifaPP: kea.validation.required,
        CantGuias: kea.validation.range(1),
        IdSucursal: kea.validation.required
    }

    return kea.validation.getErrors(rules, x);
}

/**Datos del paquete de PP */
export class DatosPaqueteView extends React.PureComponent<Props> {
    value = (x: Props) => x.value;
    serviciosAdicionales = (x: Props) => x.value.ServiciosAdicionales;
    errors = createSelector(this.value, x => validar(x));
    getField = kea.formfields(() => this.props, () => this.errors(this.props));

    handleOnTarifaPPChange = async (idTarifaPP: number | undefined | null) => {
        var cambio: Partial<Entity> = { IdTarifaPP: idTarifaPP as any };
        var value = this.value(this.props);
        this.props.onChange({ ...value, ...cambio });
        var serviciosAdicionales = this.serviciosAdicionales(this.props);
        if ((serviciosAdicionales == undefined || serviciosAdicionales == null) && idTarifaPP) {
            var tarifaPP = await resources.TarifaPP.get(idTarifaPP);
            cambio.ServiciosAdicionales = tarifaPP.ServiciosAdicionales;
        }

        this.props.onChange({ ...value, ...cambio });
    }

    render() {
        const Cliente = this.getField(selectores.Cliente);
        const Tarifa = this.getField(selectores.TarifaPP);
        const Number = this.getField(kea.Number);
        const Check = this.getField(kea.Checkbox);
        const Sucursal = this.getField(selectores.Sucursal);
        const ServAdic = this.getField(ServiciosAdicionales);
        const Text = this.getField(kea.Text);

        return (
            <div>
                <kea.Panel title="Datos generales">
                    {kea.autogrid(4, [
                        <Cliente field="IdCliente" label="Cliente" />,
                        <Tarifa field="IdTarifaPP" label="Tarifa PP" onChange={this.handleOnTarifaPPChange} />,
                        <Number field="CantGuias" label="Cant. guías" format="int" />,
                        <Check field="AplicaPaquete" label="Aplica paquete" />,
                        <Check field="AplicaSobre" label="Aplica sobre" />,
                        <Sucursal field="IdSucursal" label="Suc. de facturación" />,
                    ])}

                    <ServAdic field="ServiciosAdicionales" /> 
                </kea.Panel>

                <kea.Panel title="Leyendas a incluir">
                    {kea.autogrid(6, [
                        <Cliente field="IdClienteOrigen" label="Cliente origen" />,
                        <Cliente field="IdClienteDestino" label="Cliente destino" />,
                        <Text field="Observaciones" placeholder="observaciones" style={{width:'100%'}}  ></Text>
                    ])}
                </kea.Panel>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/paquetespp/edit/datosView.tsx